import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetTrendsTableRequestDtoSchema = z.object({
  facilityId: z.number(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']),
  from: z.string(),
  to: z.string(),
});

const GetTrendsTableResponseDtoSchema = z.array(
  z.object({
    label: z.string(),
    period: z.string(),
    amr: z.object({
      owned: z.number().nullable(),
      comp: z.number().nullable(),
      delta: z.number().nullable(),
    }),
    margin: z.object({
      owned: z.number().nullable(),
      comp: z.number().nullable(),
      delta: z.number().nullable(),
    }),
    occupancy: z.object({
      owned: z.number().nullable(),
      comp: z.number().nullable(),
      delta: z.number().nullable(),
    }),
    residentRetention: z.object({
      owned: z.number().nullable(),
      comp: z.number().nullable(),
      delta: z.number().nullable(),
    }),
    totalAdmissions: z.object({
      owned: z.number().nullable(),
      comp: z.number().nullable(),
      delta: z.number().nullable(),
    }),
    totalDischarges: z.object({
      owned: z.number().nullable(),
      comp: z.number().nullable(),
      delta: z.number().nullable(),
    }),
  })
);

export type GetTrendsTableRequestDto = z.infer<
  typeof _GetTrendsTableRequestDtoSchema
>;
export type GetTrendsTableResponseDto = z.infer<
  typeof GetTrendsTableResponseDtoSchema
>;

export const getTrendsTable = (
  params: GetTrendsTableRequestDto,
  config?: AxiosRequestConfig<GetTrendsTableRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`market-intelligence/facilities/${facilityId}/trends-table`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetTrendsTableResponseDtoSchema));
};
